/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var Hook = require("./Hook");
var HookCodeFactory = require("./HookCodeFactory");
var SyncWaterfallHookCodeFactory = /*#__PURE__*/ function(HookCodeFactory) {
    _inherits._(SyncWaterfallHookCodeFactory, HookCodeFactory);
    function SyncWaterfallHookCodeFactory() {
        _class_call_check._(this, SyncWaterfallHookCodeFactory);
        return _call_super._(this, SyncWaterfallHookCodeFactory, arguments);
    }
    _create_class._(SyncWaterfallHookCodeFactory, [
        {
            key: "content",
            value: function content(param) {
                var onError = param.onError, onResult = param.onResult, resultReturns = param.resultReturns, rethrowIfPossible = param.rethrowIfPossible;
                return this.callTapsSeries({
                    onError: (i, err)=>onError(err),
                    onResult: (i, result, next)=>{
                        var code = "";
                        code += `if(${result} !== undefined) {\n`;
                        code += `${this._args[0]} = ${result};\n`;
                        code += "}\n";
                        code += next();
                        return code;
                    },
                    onDone: ()=>onResult(this._args[0]),
                    doneReturns: resultReturns,
                    rethrowIfPossible
                });
            }
        }
    ]);
    return SyncWaterfallHookCodeFactory;
}(HookCodeFactory);
var factory = new SyncWaterfallHookCodeFactory();
var TAP_ASYNC = ()=>{
    throw new Error("tapAsync is not supported on a SyncWaterfallHook");
};
var TAP_PROMISE = ()=>{
    throw new Error("tapPromise is not supported on a SyncWaterfallHook");
};
function COMPILE(options) {
    factory.setup(this, options);
    return factory.create(options);
}
function SyncWaterfallHook() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    if (args.length < 1) {
        throw new Error("Waterfall hooks must have at least one argument");
    }
    var hook = new Hook(args, name);
    hook.constructor = SyncWaterfallHook;
    hook.tapAsync = TAP_ASYNC;
    hook.tapPromise = TAP_PROMISE;
    hook.compile = COMPILE;
    return hook;
}
SyncWaterfallHook.prototype = null;
module.exports = SyncWaterfallHook;
